module.exports = __webpack_public_path__ + "ui-bg_highlight-soft_100_eeeeee_1x100.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-bg_highlight-soft_100_eeeeee_1x100.png
// module id = 802
// module chunks = 1